'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = customerDetail;

var _ajaxHelper = require('../ajaxHelper');

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function customerDetail() {

    var editedCustomerIdInput = document.getElementById('editedCustomerIdInput');
    var customerFbCheckBox = document.getElementById('customerForbidden');
    if (customerFbCheckBox && editedCustomerIdInput) customerFbCheckBox.addEventListener('change', forbiddenChange);

    function forbiddenChange(event) {
        try {
            var ajaxHelper = new _ajaxHelper2.default();
            var savingObjectSerialized = JSON.stringify({
                customerId: parseInt(editedCustomerIdInput.value),
                isDeleted: event.target.checked
            });

            ajaxHelper.sendRequest('/Customer/SaveCustomerDetailIsDeleted', SaveIsDeletedComplete, savingObjectSerialized);
        } catch (e) {
            console.error('Error saving forbidden (IsDeleted) value for customer.', e);
        }
    }

    function SaveIsDeletedComplete(httpRequest, rspObj) {
        console.debug(httpRequest, rspObj);
    }
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/customerDetail.js
// module id = 404
// module chunks = 0